<form action="" autocomplete="off"  (ngSubmit)="onSubmit(paymentForm.valid)" #paymentForm="ngForm">
<div class="col-md-12 container">
  <!--<div class="flex-container" style="margin-bottom: 33px;">
    <div style="margin-top: 20px">
     <span  style="width: 14px;height: 14px;background-color: deepskyblue;border-radius: 50%;border: 1px solid grey;margin-right: 17px;display: inline-block"></span>
     <img width="35" height="35" src="../../../assets/imgs/credit-card.png" alt="">
     <span style="margin-left: 10px">Carte Bancaire</span>
    </div>
  </div>-->


  <div style="color: red;font-style: italic" *ngIf="errors.length">
    <ul>
      <li *ngFor="let error of errors">{{error}}</li>
    </ul>
  </div>

  <div style="font-style: italic" *ngIf="pendingRequest">
    <ul>
      {{'payment_module.loading'| translate}}
    </ul>
  </div>

  <div *ngIf="order.total_price > 0">

  <div class="form-group row col-md-12 fo-form-group fo-form-group-required" [ngClass]="{'has-danger': card_number.errors && (card_number.dirty || card_number.touched || errors.length)}">
    <label for="card_number">{{'payment_module.card_number'| translate}}</label>
    <input autocomplete="none" mask="0000 0000 0000 0000" type="text" name="card_number" #card_number="ngModel" required [(ngModel)]="bankData.card_number" class="form-control" id="card_number"  placeholder="1234 5678 9012 3456">
    <div class="form-control-feedback alert alert-danger custom-alert-danger">{{'payment_module.card_number_is_required'| translate}}</div>
  </div>

  <div class="row col-md-12">

    <div class="form-group  col-md-6 form-group fo-form-group fo-form-group-required" style="padding-left: 0px!important; " [ngClass]="{'has-danger': exp.errors && (exp.dirty || exp.touched || errors.length)}">

      <label for="exp_date">{{'payment_module.expiration_date'| translate}}</label>


      <div style="display: block">

        <!--<select style="display: inline-block!important;" required name="exp_month" id="exp_month" class="form-control col-md-5" #exp_month1="ngModel"  [(ngModel)]="exp_month">
          <option  *ngFor = 'let item of monthsArray' value="{{ item }}" >{{ item}}</option>
        </select>

        <select style="display: inline-block!important;" required name="exp_day" id="exp_date" class="form-control col-md-5" #exp_day1="ngModel"   [(ngModel)]="exp_day">
            <option  *ngFor = 'let item of daysArray' value="{{ item }}" >{{ item}}</option>
         </select>-->
         <input type="text" placeholder="12/24" id="exp_date"  class="form-control" name="exp_day" mask="00/00" required [(ngModel)]="bankData.exp_date" #exp="ngModel">

      </div>

      <!--<input [(ngModel)]="bankData.exp_date" #exp_date="ngModel" required name="exp_date" type="text" class="form-control" id="exp_date"  placeholder="Entrer la date d'expiration">-->
      <div class="form-control-feedback alert alert-danger custom-alert-danger">{{'payment_module.expiration_date_is_required'| translate}}</div>
    </div>

    <div class="form-group  col-md-6 form-group fo-form-group fo-form-group-required" style="padding-right: 0px!important;" [ngClass]="{'has-danger': cryptogramme.errors && (cryptogramme.dirty || cryptogramme.touched || errors.length)}">
      <label for="cryptogramme">{{'payment_module.cryptogram'| translate}}</label>
      <input type="text" #cryptogramme="ngModel" mask="000" required name="cryptogramme" [(ngModel)]="bankData.cryptogramme" class="form-control" id="cryptogramme"  placeholder="123">
      <div class="form-control-feedback alert alert-danger custom-alert-danger">{{'payment_module.cryptogram_is_required'| translate}}</div>
    </div>
  </div>

  <div class="row col-md-12 form-group fo-form-group fo-form-group-required" [ngClass]="{'has-danger': card_username.errors && (card_username.dirty || card_username.touched || errors.length)}">
    <label for="card_username">{{'payment_module.name_of_the_card_holder'| translate}}</label>
    <input type="text" #card_username="ngModel" required name="card_username"  [(ngModel)]="bankData.card_username" class="form-control" id="card_username"  placeholder="Entrer le nom du titulaire de la carte">
    <div class="form-control-feedback alert alert-danger custom-alert-danger">{{'payment_module.card_holder_name_is_required'| translate}}</div>
  </div>
  </div>


  <div class="form-group row col-md-12 flex-align-center" style="margin-top: 60px">
    <button type="submit" *ngIf="!pendingRequest && order.total_price > 0" [disabled]="pendingRequest" style="background-color: var(--btn-bgColor)" title="Valider mon paiement" class="btn inline-block btn-green width-100-475" >{{'payment_module.pay'| translate}}</button>
    <button type="submit" *ngIf="isFree(pendingRequest,order)" [disabled]="pendingRequest" style="background-color: var(--btn-bgColor)" title="Valider mon paiement" class="btn inline-block btn-green width-100-475" >{{'payment_module.continue'| translate}}</button>
    <button type="submit" *ngIf="pendingRequest" disabled style="background-color:grey" title="chargement..." class="btn inline-block btn-green width-100-475" >{{'payment_module.loading'| translate}}</button>
  </div>

  </div>

</form>
